import { render, staticRenderFns } from "./FeatureInfo.vue?vue&type=template&id=81c485fc&scoped=true"
import script from "./FeatureInfo.vue?vue&type=script&lang=js"
export * from "./FeatureInfo.vue?vue&type=script&lang=js"
import style0 from "./FeatureInfo.vue?vue&type=style&index=0&id=81c485fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81c485fc",
  null
  
)

export default component.exports